import React, { Component } from 'react';
import Button from "@material-ui/core/Button";
import NonOpImage from "../../assets/non-op.png";
import "./JointNoi1.css"

class JointNoi6 extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }
    render() {
        return (
            <div id="RCPE-Welcome-main-container">
                <div id="all-content-wrapper">
                    <div id="RCPE-Welcome-box-1">
                        <div id="JointNoi3-inner-box-1">

                            {/* Dic 1 */}
                            <div id="RCPNOI-container-1">
                                <h2 id="RCPNOI-heading"> {`How to best prepare for surgery`} </h2>

                                <div id="RCPNOI-form-box-1">
                                    
                                    <form id="RCPNOI-form">
                                        <ul className="RCPNOI-unstyled RCPNOIcentered">

                                            {["Prehab Exercises","Smoking Cessation?","Weight management","Nutritional Support","Reducing your anxiety","Managing your Discomfort","Complimentary Alternative Pain Treatments"].map((text)=>
                                                <li>
                                                    <label htmlFor={text} className="RCPNOI-form-field">
                                                        {text}
                                                    </label>
                                                </li>
                                            )}
                                        </ul>      
                                    </form>

                                    <img alt="App-Image" src={NonOpImage} id="JN1-Image" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div id="RCPE-Welcome-box-2">
                        <div id="RCPE-Welcome-footer-div1">
                            <Button
                                id="RCPE-Welcome-btn-1"
                                variant="contained"
                                onClick={this.props.handleBackClick}
                            >
                                {" "} Back {" "}
                            </Button>
                        </div>

                    </div>

                </div>
                
            </div>
        );
    }
}

export default JointNoi6;